import React from 'react';
import { Helmet } from 'react-helmet';
var Twitter = function (_a) {
    var _b = _a.cardType, cardType = _b === void 0 ? 'summary_large_image' : _b, username = _a.username, title = _a.title, description = _a.description, image = _a.image;
    return (React.createElement(Helmet, null,
        React.createElement("meta", { name: "twitter:card", content: cardType }),
        username && React.createElement("meta", { name: "twitter:creator", content: username }),
        title && React.createElement("meta", { name: "twitter:title", content: title }),
        description && React.createElement("meta", { name: "twitter:description", content: description }),
        image && React.createElement("meta", { name: "twitter:image", content: image })));
};
export default Twitter;
//# sourceMappingURL=Twitter.js.map